/** Data Dictionary: NIC / passport formats, max 15. */
export function isValidNicOrPassport(s: string): boolean {
  const t = s.trim();
  if (!t || t.length > 15) return false;
  return /^(?:\d{12}|\d{9}[VvXx]|[A-Za-z]\d{7})$/.test(t);
}

export function digitsOnlyMax10(raw: string): string {
  return raw.replace(/\D/g, '').slice(0, 10);
}

export type UserRoleDisplayEntry = {
  roleName: string;
  defaultRole: boolean;
};

function stripDefaultRoleSuffix(roleName: string): string {
  return roleName.replace(/\s*\(Default\)\s*$/i, '').trim();
}

/** Read-only display for profile / view screens (e.g. "Internal User (Default), Supervising Officer"). */
export function formatUserRolesDisplay(roles: UserRoleDisplayEntry[]): string {
  if (!roles.length) return '';
  return roles
    .map((x) => {
      const name = stripDefaultRoleSuffix(x.roleName);
      return `${name}${x.defaultRole ? ' (Default)' : ''}`;
    })
    .join(', ');
}
